<template>
  <component :is="dialogConf.type" :row="dialogConf.row"></component>
</template>

<script>
import { mapState, mapMutations } from "vuex";
let components = {};

Object.values(CONSTANT.DIALOG_TYPE).forEach((type) => {
  components[type] = () => import(`./${type}`);
});

export default {
  computed: {
    ...mapState({
      dialogConf: (state) => state.dialogConf,
    }),
  },
  components,
};
</script>

<style></style>
